/* import __COLOCATED_TEMPLATE__ from './dac-option.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

import Constants from '../utils/constants';
import Utils from '../utils/utils';

export default class DacOption extends Component {
  @service intl;
  @service tabService;
  @service dataService;
  @service('aditools-analytics') analytics;

  svgLocation = 'svgs/topology/icons';
  svgContainerClass = 'dac-svg-container';

  get label() {
    return this.intl.t(`labels.parts.${this.args.option.appName}`);
  }

  get active() {
    const selectedOption = this.args.model.signalChainHandler.dac.type;
    return selectedOption && this.args.option
      ? selectedOption.id === this.args.option.id
      : false;
  }

  @action async selectDacOption() {
    this.args.model.markAsNotReady();

    console.time('get dac grid data');
    let gridData = null;

    if (this.args.option.pst && this.args.option.pst.id) {
      gridData = await this.dataService.getDatabookGridData(
        this.args.option.pst,
        this.args.model.urlHandler.homeUrl,
      );
    } else
      console.warn(
        `Loading Dac Option (${this.args.option.name}): There is no pst configured.`,
      );

    console.timeEnd('get dac grid data');
    if (!this.isDestroying && !this.isDestroyed) {
      if (gridData && gridData.data) {
        this.args.model.handleDacTypeChange(this.args.option, gridData);
        this.tabService.setTab(Constants.TAB.NEXT);

        if (this.args.updateAppData) this.args.updateAppData();

        this.args.model.markAsReady();

        this.analytics.setWebEvent(
          Utils.getToolName(),
          'selectDacType',
          this.args.option.analyticsName || this.args.option.name,
        );
      } else {
        this.args.model.modalHandler.displayNotification(
          this.intl.t('messages.title', { htmlSafe: 'true' }),
          this.intl.t('messages.error-grid-data'),
        );
        console.error(
          `Grid data could not be found for dac (${this.args.option.name}) pst (${
            this.args.option.pst ? this.args.option.pst.id : ''
          })`,
        );

        this.args.model.markAsReady();
      }
    }
  }
}
